import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import EditLayout from 'layouts/crud/EditLayout'
import EditFormActions from 'layouts/crud/EditFormActions'
import FormCard from 'ui/cards/FormCard'
import Title from 'layouts/page/Title'

export default class Edit extends CrudPageContent {
  get resourceName () {
    return 'users.admins'
  }

  get layout () {
    return EditLayout
  }

  get actions () {
    return <EditFormActions />
  }

  get fields () {
    return (
      <FormCard header={<Title />}>
        <Fieldset cols={2}>
          <Fields.Input name='name' label='Navn' />
          <Fields.Input name='email' label='E-mail' />
          <Fields.Select
            name='role_name'
            enum='user_roles'
            only={['admin']}
            placeholder='Vælg rolle'
            label='Rolle'
          />
        </Fieldset>
      </FormCard>
    )
  }
}
